import { GalleryConfig } from 'rangeConfig/@types';

const eketGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-19286413' },
        { id: 'SPR-29430151' },
        { id: 'SPR-79388003' },
        { id: 'SPR-49490295' },
        { id: 'SPR-99568833' },
        { id: 'SPR-79494471' },
        { id: 'SPR-39490465' },
        { id: 'SPR-09521680' },
        { id: 'SPR-39431560' },
        { id: 'SPR-89386131' },
        { id: 'SPR-29568841' }
      ]
    }
  ]
};

export default eketGalleryConfig;
